export default __webpack_public_path__ + "static/media/Luis.3639d93d.png";